import axios from 'axios';

import { axiosQueue } from '@/bundles/Auth/services/AxiosQueue';
import { REQUEST_CANCELLED_MESSAGE } from '@/bundles/Http/mappers/ErrorMapper';

export const resetTokenAndReattempRequest = async (error) => {
  try {
    const skipRefreshTokenUrls = ['/compensation']

    if (axios.isCancel(error)) {
      throw Error(REQUEST_CANCELLED_MESSAGE);
    }
    if (skipRefreshTokenUrls.some(url => error.response?.request?.responseURL?.includes(url)) && error.response?.status === 401) {
      throw error
    }
    if (error.headers?.cached) {
      return error
    }
    const { response: errorResponse } = error
    // 403 is a permission error (the API answers it for e.g. super-admin-only actions or
    // another member's settings), not an ended session: the caller shows it, like the v2 client
    if (errorResponse.status === 401) {
      return new Promise((resolve, reject) => axiosQueue.addToQueue(errorResponse.config, resolve, reject));
    }
    return await Promise.reject(error)
  } catch (e) {
    // eslint-disable-next-line no-return-await
    return await Promise.reject(e)
  }
}
